import { render, staticRenderFns } from "./new_assur_care.vue?vue&type=template&id=382fcd05&scoped=true"
import script from "./new_assur_care.vue?vue&type=script&lang=js"
export * from "./new_assur_care.vue?vue&type=script&lang=js"
import style0 from "./new_assur_care.vue?vue&type=style&index=0&id=382fcd05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382fcd05",
  null
  
)

export default component.exports